import z from 'zod';

export const PostSnapLikedServiceRequestSchema = z
  .object({
    snapId: z.string(),
  })
  .describe('PostSnapLikedServiceRequestSchema');

export type PostSnapLikedServiceRequest = z.infer<typeof PostSnapLikedServiceRequestSchema>;

export const PostSnapLikedServiceResponseSchema = z
  .object({
    success: z.boolean(),
  })
  .describe('PostSnapLikedServiceResponseSchema');

export type PostSnapLikedServiceResponse = z.infer<typeof PostSnapLikedServiceResponseSchema>;
